import { render, staticRenderFns } from "./BankStatementInformationTable.vue?vue&type=template&id=fdd29d18&scoped=true&"
import script from "./BankStatementInformationTable.vue?vue&type=script&lang=js&"
export * from "./BankStatementInformationTable.vue?vue&type=script&lang=js&"
import style0 from "./BankStatementInformationTable.vue?vue&type=style&index=0&id=fdd29d18&scoped=true&lang=css&"
import style1 from "./BankStatementInformationTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd29d18",
  null
  
)

export default component.exports